/* qtrat 2026-10-23: WhatsApp buttons carry the product or the cart (Wasim picked suggestion 2).
   Product page: «مرحباً، لديّ بعض الأسئلة عن هذا المنتج:» + product name + link.
   Cart page: the same greeting + every cart line with its quantity + the total + the delivery line
   (free from 29 JOD, else 2 JOD and the total with delivery; same as the store's two shipping rates).
   Changed: links and chat-app buttons that open the store number 962781620564 (or its short link
   wa.me/message/MNR5OOS47MJPI1) with no message or with the chat app's generic «لديّ بعض الأسئلة».
   Left alone: any link that already carries its own message (back-in-stock button, share card).
   Loaded on product and cart pages only, with window.qtratWa set by layout/theme.liquid.
   Source: Desktop/qatarat/2026-10-23-homepage/sitewide/qtrat-wa.js */
(function () {
  'use strict';
  var C = window.qtratWa || {};
  if (window.__qtratWaOn || (C.t !== 'product' && C.t !== 'cart')) return;
  window.__qtratWaOn = true;
  var PHONE = '962781620564', SHORT = 'message/MNR5OOS47MJPI1';
  var GENERIC = ['', 'لديّ بعض الأسئلة', 'لدي بعض الأسئلة'];
  var RLM = '\u200F';  // keeps an Arabic line right-to-left when it starts with a Latin product name
  var EN = /^en/i.test(C.lang || '');
  var cart = null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function loadCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; })
      .catch(function () {});
  }

  function money(cents) { return (Number(cents || 0) / 100).toFixed(2); }
  var FREE_FROM = 2900, FEE = 200;  // cents: Shopify rates «توصيل داخل الأردن» = 2 JOD up to 28.999, free from 29

  function message() {
    if (C.t === 'product') {
      if (!C.title) return '';
      return EN
        ? 'Hello, I have some questions about this product:\n' + C.title + '\nProduct link: ' + C.url
        : 'مرحباً، لديّ بعض الأسئلة عن هذا المنتج:\n' + RLM + C.title + '\nرابط المنتج: ' + C.url;
    }
    if (!cart || !cart.items || !cart.items.length) return '';
    var lines = cart.items.slice(0, 15).map(function (i) {
      var v = i.variant_title && !/default title/i.test(i.variant_title) ? ' - ' + i.variant_title : '';
      var gift = Number(i.final_line_price) === 0 ? (EN ? ' (free gift)' : ' (هدية مجانية)') : '';
      return EN
        ? '- ' + i.product_title + v + ' (Qty: ' + i.quantity + ')' + gift
        : RLM + '- ' + i.product_title + v + ' (الكمية: ' + i.quantity + ')' + gift;
    });
    return (EN ? 'Hello, I have some questions about these products in my cart:\n'
               : 'مرحباً، لديّ بعض الأسئلة عن هذه المنتجات في سلتي:\n') +
      lines.join('\n') + '\n' +
      (EN ? 'Total: ' + money(cart.total_price) + ' JOD' : 'المجموع: ' + money(cart.total_price) + ' دينار') + '\n' +
      (cart.total_price >= FREE_FROM
        ? (EN ? 'Delivery: free' : 'التوصيل: مجاني')
        : (EN ? 'Delivery: 2 JOD\nTotal with delivery: ' + money(cart.total_price + FEE) + ' JOD'
              : 'التوصيل: ديناران\nالمجموع مع التوصيل: ' + money(cart.total_price + FEE) + ' دينار'));
  }

  function storeChat(u) {
    var host = u.hostname.replace(/^www\./, '');
    if (host === 'wa.me') {
      var p = u.pathname.replace(/^\/+|\/+$/g, '');
      return p === PHONE || p === SHORT;
    }
    if (host === 'api.whatsapp.com' || host === 'web.whatsapp.com' || u.protocol === 'whatsapp:') {
      return (u.searchParams.get('phone') || '').replace(/\D/g, '') === PHONE;
    }
    return false;
  }

  function rewrite(href) {
    var u;
    try { u = new URL(href, location.href); } catch (e) { return href; }
    if (!storeChat(u)) return href;
    if (GENERIC.indexOf((u.searchParams.get('text') || '').trim()) === -1) return href;  // has its own message
    var msg = message();
    if (!msg) return href;
    var enc = encodeURIComponent(msg);
    if (u.hostname.replace(/^www\./, '') === 'wa.me') return 'https://wa.me/' + PHONE + '?text=' + enc;
    var q = [], hasText = false;
    u.searchParams.forEach(function (v, k) {
      if (k === 'text') { hasText = true; q.push('text=' + enc); } else { q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); }
    });
    if (!hasText) q.push('text=' + enc);
    return u.protocol + '//' + u.host + u.pathname + '?' + q.join('&');
  }
  window.qtratWaRewrite = rewrite;  // for checks from the console

  // 1) real links on the page (FAQ number, footer icon): rewrite from the original link on every click
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var orig = a.getAttribute('data-qtrat-wa-orig') || a.href;
    var next = rewrite(orig);
    if (next !== orig && !a.hasAttribute('data-qtrat-wa-orig')) a.setAttribute('data-qtrat-wa-orig', orig);
    if (a.hasAttribute('data-qtrat-wa-orig')) a.href = next;  // back to the plain link when there is nothing to say
  }, true);

  // 2) the floating chat-app button builds a link in script and clicks it, or calls window.open
  var aClick = HTMLAnchorElement.prototype.click;
  HTMLAnchorElement.prototype.click = function () {
    try {
      if (this.href) { var n = rewrite(this.href); if (n !== this.href) this.href = n; }
    } catch (e) {}
    return aClick.apply(this, arguments);
  };
  var wOpen = window.open;
  window.open = function (url) {
    var args = Array.prototype.slice.call(arguments);
    try { if (typeof url === 'string') args[0] = rewrite(url); } catch (e) {}
    return wOpen.apply(window, args);
  };

  // 3) the cart: read it now and again after every change, so the message matches what the customer sees
  if (C.t === 'cart') {
    loadCart();
    var f = window.fetch;
    window.fetch = function (input) {
      var p = f.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(loadCart, 60); }, function () {});
      } catch (e) {}
      return p;
    };
    // fallback for cart scripts that kept their own fetch reference: the cart form re-renders after each change
    // (debounced: reads the cart once the form has been quiet for 600 ms)
    var timer = null;
    var form = document.querySelector('form[action*="/cart"]');
    if (form && window.MutationObserver) {
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(loadCart, 600);
      }).observe(form, { childList: true, subtree: true });
    }
  }
})();
